import React from 'react';
import ChartistGraph from 'react-chartist';
import '../../components/player-overview-charts/chartist.min.css';
import './player_progress_chart.css';

class PlayerProgressChart extends React.Component {
  prepareData(data) {
    const datesArray = [];
    const dataPoints = [];
    for (const key in data) {
      datesArray.push(key);
    }

    datesArray.sort(function (a, b) {
      return a < b;
    });

    for (const index in datesArray) {
      let date = datesArray[index];
      dataPoints.push(data[date]);

      date = date.substr(5);
      datesArray[index] = date;
    }

    return [datesArray, dataPoints];
  }

  render() {
    const { data } = this.props;

    const actualData = data[0];
    const title = data[1];

    const graphTitle = title[0];
    const funcType = title[2];
    const gameImagePath = title[3];
    const yAxisTitle = title[1];
    const parsedData = this.prepareData(actualData);

    if (!parsedData[1] || parsedData[1].length === 0) {
      return '';
    }
    const graphDataParsed = {
      labels: parsedData[0],
      series: [parsedData[1]],
    };

    const options = {
      low: 0,
      showLabels: true,
    };

    const type = 'Line';

    const indicatorClassName = 'func_type_indicator ' + funcType;

    const chartClassName = 'daily_progress_line_chart ' + funcType;

    const image = new URL(`../../../static/assets/game_icons/${gameImagePath}`, import.meta.url).href;

    return (
      <div className="player_progress_chart">
        <div className="player_progress_chart_title">{graphTitle}</div>
        <img className="player_progress_chart_game_image" alt="game_icon" src={image} />
        <div className="player_progress_chart_container">
          <div className="y_axis_title">
            {yAxisTitle} <span className={indicatorClassName}>({funcType})</span>
          </div>
          <ChartistGraph className={chartClassName} data={graphDataParsed} options={options} type={type} />
          <div className="x_axis_title">Date</div>
        </div>
      </div>
    );
  }
}

export default PlayerProgressChart;
